import React from 'react';
import { Card } from 'components/Card';
import { TableSimple } from 'components/TableSimple';
import { iconShield} from '../../../../assets/icons/index'
import { Container, Content } from './styles';
import { useBusinessTrust } from './useBusinessTrust';
import { Loading } from 'components/Loading';
import { PlaceHolderNotExists } from 'components/PlaceholderNotExists';
import { LineChart } from './LineChart';


interface LineChartProps {
  verifiedAt: string, //datetime
  score?: string,
  scoreFormatted?: string,
  suggestion?: string,
  downloadLink: JSX.Element,
}

export interface LineCharDataProps {
  dataAttributes: LineChartProps[];
}

export const BussinessTrust: React.FC = () => {
  const {
    businessTrustTableRows,
    isLoading,
    hasError,
    sendingBusinessTrust,
    sendBusinessTrust,
  } = useBusinessTrust();

  const businessTrustTableRowsToTable = businessTrustTableRows?.map(item => ({
    verifiedAt: item.verifiedAt,
    score: item.scoreFormatted,
    downloadLink: item.downloadLink,
  }))

  if (isLoading) {
    return (
      <Loading />
    )
  }

  if (hasError) {
    return (
      <PlaceHolderNotExists title="Erro ao tentar conectar com o servidor" />
    )
  }

  return (
    <Container>
      <Card title="" hasBorder={false}>
        <LineChart dataAttributes={businessTrustTableRows || []}/>
      </Card>

      <Card 
        title="Histórico Business Trust" 
        hasButton={true} 
        labelButton="Atualizar score" 
        typeBtn="blue"
        iconButton={iconShield}
        iconHover={iconShield}
        buttonLoad={sendingBusinessTrust}
        buttonWidth={175}
        onClick={sendingBusinessTrust ? null : sendBusinessTrust}
      >
        <Content>
          <TableSimple
            headerTable={['Verificado em', 'Score', 'Baixar relatório']}
            bodyTable={businessTrustTableRowsToTable ?? []}
          />
        </Content>
      </Card>
    </Container>
  );
}